export default "__VITE_ASSET__6018d17c__"